import { render, staticRenderFns } from "./roomSet.vue?vue&type=template&id=f3af4ed8"
import script from "./roomSet.vue?vue&type=script&lang=js"
export * from "./roomSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports